import { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import {
  People,
  Storefront,
  Agriculture,
  MonetizationOn,
  Grain,
  TrendingUp,
  Map,
  AssignmentTurnedIn,
} from "@mui/icons-material";
import StorefrontIcon from "@mui/icons-material/Storefront";
import InventoryIcon from "@mui/icons-material/Inventory";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import Chart from "react-apexcharts";
import { motion } from "framer-motion";
import { selectCurrentRoles } from "features/auth/authSlice";
import { useGetDashboardProfilebyIdQuery } from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";
import ProjectSkeleton from "../Project/ProjectSkeleton";
import EmandiReports from "features/E-Mandi/EmandiReport/emandiReport";
import { AggregationParent } from "components/Aggregation/AggregationParent";
import EmployeesList from "features/userManagement/EmployeesList";
import { ProjectCommodities } from "../Project/ProjectCommodities";
import { store } from "app/store";
import { API_URL } from "app/config";
import { FieldActivities } from "../Project/FieldActivities";
import FPOContainer from "features/onboarding/organizations/FarmersGroup/FPO/FPOContainer";
import ProjectFpoTab from "../Project/ProjectFpoTab";
import HclProjectFarmerNewComponent from "./HclProjectFarmerNewComponent";
import { Mandi } from "features/E-Mandi/EmandiReport/Mandi";
import { Spinner } from "react-bootstrap";
import { useGetFPOListQuery } from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";
import { FieldActivitiesNewUi } from "./FieldActivitiesNewUi";
import ProjectProcurementParentComponnet from "./ProjectProcurementParentComponnet";
import { ProjectAdvisorySection } from "./ProjectAdvisorySection";
import { selectLanguage } from "features/auth/authSlice";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";

import { useTranslation } from "react-i18next";

import { Alaap_dev, CMS_maati } from "urlconfig";
import { OliveBaselineAssessment } from "./OliveBaselineAssessment";
import OliveProjectComp from "./OliveProjectComp";
import ProjectNavbar from "../Project/ProjectNavbar";
import OliveProjectFarmers from "./OliveProjectFarmers";
const OliveProjectDashboard = () => {
  const { id } = useParams();
//   const orgId = id || "";
//   const orgId="3e129491-515d-4fcb-9f36-4a42dfc7053d";

  // const currentUser = useSelector(selectCurrentUser);
  const [totalFarmers, setTotalFarmers] = useState("");
    const[orgId,setOrgId]=useState("3e129491-515d-4fcb-9f36-4a42dfc7053d")

  const { data: userProfile, isLoading } = useGetDashboardProfilebyIdQuery(
    orgId,
    {
      refetchOnMountOrArgChange: true,
      pollingInterval: 900000,
    }
  );
  const { t, i18n } = useTranslation();
  const language = useSelector(selectLanguage);
  const [apiData, setApiData] = useState({});
  const [activeMenu, setActiveMenu] = useState(null);
  const [filteredTabs, setFilteredTabs] = useState([]);
  const [cropCount, setCropsCount] = useState("");
  const [mandiCard, setMandiCard] = useState({
    total: "",
    sum: "",
    totalQuantity: 0,
  });
  const RolesFromToken = useSelector(selectCurrentRoles);
    // console.log("RolesFromToken?.groups",RolesFromToken)

  const formatProcurement = () => {
    const quantity = mandiCard?.totalQuantity || 0;
    if (quantity < 1000) return `${Math.round(quantity).toLocaleString()} Kg`;
    if (quantity < 10000)
      return `${Math.round(quantity / 100).toLocaleString()} Quintal`;
    return `${Math.round(quantity / 1000).toLocaleString()} MT`;
  };
  useEffect(() => {
    if (userProfile?.data) {
      setApiData(userProfile.data);
    }
  }, [userProfile]);
//   useEffect(() => {
//   console.log("updated org");
// }, [orgId]);

  useEffect(() => {
    fetch(
      `${CMS_maati}/api/farmer-crop-level-1s?filters[farmer_crop_level_1][page]=1&pagination`
    ).then((res) =>
      res.json().then((data) => setCropsCount(data?.meta?.pagination?.total))
    );
  }, []);
   useEffect(() => {
      localStorage.removeItem("projectId");
    }, []);

  const { data: CommoditiesData, refetch } = useGetFPOListQuery({
    pagination: "",
    searchKey: "",
    orgId,
  });
  // const fpoName = currentUser?.organization_name ?? "";
  const project = apiData?.organization_details?.project ?? null;
  const modules = project?.modules ?? {};
  const hasEMandiModule = Object.keys(modules).includes("E-Mandi");
  const projectName = project?.project_name || "";
  const isCBBO = apiData?.organization_details?.organization_type === "CBBO";
  const organisation_name = id
    ? userProfile?.data?.organization_details?.organization_name
    : RolesFromToken?.organization_name;

  const organisation_id = id ? id : RolesFromToken?.organization_id;
  const SaptashatiUrl = project?.SaptashatiUrl || "";
  const AdvisoryUrl = project?.AdvisoryUrl || "";
  const selectedCommodities = project?.selectedCommodities || "";
  const firstCrop = project?.crops?.[0] || "";
  const firstState = project?.states?.[0]?.label || "";
  const firstDistrict = project?.districts?.[0]?.label || "";
  const firstStateCode = project?.states?.[0]?.value || "";
  const firstDistrictCode = project?.districts?.[0]?.value || "";

  const totalCommodities =
    CommoditiesData?.data?.results?.reduce((sum, item) => {
      const currentLevel = Array.isArray(item?.project?.selectedCommodities)
        ? item.project.selectedCommodities.length
        : 0;

      const totalForItem = currentLevel;

      return sum + totalForItem;
    }, 0) ?? 0;
  
  // useEffect(() => {
  //   if (project) {
  //     if (project?.region_url) {
  //       if (project?.region_url) {
  //         setTotalFarmers(0);
  //         return;
  //       }
  //     }
  //     const fetchFarmers = async () => {
  //       try {
  //         const response = await fetch(
  //           `${CMS_maati}/api/farmer-basic-details?pagination[pageSize]=25`
  //         );
  //         const data = await response.json();
  //         setTotalFarmers(data?.meta?.pagination?.total);
  //       } catch (err) {
  //         console.log("Failed to fetch farmers");
  //       }
  //     };

  //     fetchFarmers();
  //   }
  // }, [project]);
  // console.log("totalFarmers",totalFarmers)
  const fetchFarmers = async (url) => {
  try {
    const response = await fetch(url);
    const data = await response.json();
    setTotalFarmers(data?.meta?.pagination?.total || 0);
  } catch (err) {
    console.error("Failed to fetch farmers", err);
  }
};

useEffect(() => {
  if (!project) return;

  if (project.region_url) {
    fetchFarmers(`${Alaap_dev}/api/alaap-respondent-details`);
  } else {
    fetchFarmers(
      `${CMS_maati}/api/farmer-basic-details?pagination[pageSize]=25`
    );
  }
}, [project]);

  const baseCBBOCards = [
    {
      title: modules["FPO"] || "FPO",
      icon: "/assets/img/corporation.png",
      total: apiData?.total_fpos ?? 0,
    },
    {
      title: "Commodities",
      icon: "https://onboarding.agrani.io/assets/wheat-Cd8AZQ9X.png",
      total:
        totalCommodities > 0
          ? totalCommodities
          : Array.isArray(selectedCommodities)
          ? selectedCommodities.length
          : 0,
    },
    {
      title:
        projectName === "Project MAATI - Baseline Assessment of Value Chain"
          ? modules["Surveys"] || "Surveys"
          : modules["Farmers"] || "Farmers",
      icon: "https://onboarding.agrani.io/assets/farmers-CTZXnfqs.png",
      total:
        projectName === "Project MAATI - Baseline Assessment of Value Chain"
          ? cropCount
          : totalFarmers ?? 0,
    },
    {
      title: "Land Holding",
      icon: "https://onboarding.agrani.io/assets/acerage-CbrTaoRH.png",
      total: apiData?.land_holding ?? 0,
    },
  ];

  

  const baseFPOCards = [
    {
      title: "Commodities",
      icon: "https://onboarding.agrani.io/assets/wheat-Cd8AZQ9X.png",
      total: apiData?.crops_dealing?.length ?? 0,
    },
    {
      title: "Farmers",
      icon: "https://onboarding.agrani.io/assets/farmers-CTZXnfqs.png",
      total: totalFarmers ?? 0,
    },
    {
      title: "Land Holding",
      icon: "https://onboarding.agrani.io/assets/acerage-CbrTaoRH.png",
      total: apiData?.land_holding ?? 0,
    },
  ];

  if (project) {
   
  } else if (project && !hasEMandiModule) {
    baseFPOCards.push({
      title: "Employees",
      icon: "https://onboarding.agrani.io/assets/staff-BoxwbA8A.png",
      total: apiData?.total_employees ?? 0,
    });
  }

  const cards = isCBBO ? baseCBBOCards : baseFPOCards;
  const menuItems = useMemo(() => {
    if (!project && !isCBBO) return [];

    const items = [
      {
        key: "FPO",
        label: "FPO",
        icon: <People />,
        component: project ? (
          <ProjectFpoTab
            projectExist={project}
            cards={cards}
            orgAdmin={orgId}
          />
        ) : (
          <FPOContainer />
        ),
        color: "#FF8E53",
      },
      {
        key: "Cluster Map",
        label: "Cluster Map",
        icon: <Map />,
        component: (
          <HclProjectFarmerNewComponent
            showMap={true}
            projectExist={project || {}}
          />
        ),
        color: "#6C63FF",
      },
      {
        key: "Farmers",
        label: "Farmers",
        icon: <People />,
        component: (
          <OliveProjectFarmers
            showMap={false}
            projectExist={project || {}}
            firstState={firstState}
            firstDistrict={firstDistrict}
            firstStateCode={firstStateCode}
            firstDistrictCode={firstDistrictCode}
          />
        ),
        color: "#FF8E53",
      },
      {
        key: "Commodities",
        label: "Commodities",
        icon: <Grain />,
        component: project?.traderOnboard ? (
          <ProjectProcurementParentComponnet
            orgId={orgId}
            showTab="Commodity"
          />
        ) : (
          <ProjectCommodities selectedCommodities={selectedCommodities} />
        ),

        color: "#6C63FF",
      },

      {
        key: "Live Mandi Prices",
        label: "Live Mandi Prices",
        icon: <TrendingUp />,
        component: (
          <EmandiReports
            isHCL
            crop={firstCrop}
            firstState={firstState}
            firstDistrict={firstDistrict}
          />
        ),
        color: "#6C63FF",
      },
      {
        key: "E-Mandi",
        label: "E-Mandi",
        icon: <Storefront />,
        component: <Mandi isHCL />,
        color: "#6C63FF",
      },


      {
        key: "Aggregation",
        label: "Aggregation",
        icon: <Agriculture />,
        component: (
          <AggregationParent
            crops={apiData?.crops_dealing}
            organisation_name={organisation_name}
            organisation_id={organisation_id}
          />
        ),
        color: "#2EC4B6",
      },
      {
        key: "Employees",
        label: "Employees",
        icon: <People />,
        component: <EmployeesList />,
        color: "#FFBF69",
      },
      {
        key: "Advisory",
        label: "Advisory",
        icon: <People />,
        // component: <ProjectAdvisory AdvisoryUrl={AdvisoryUrl} />,
        component: (
          <ProjectAdvisorySection orgId={orgId} AdvisoryUrl={AdvisoryUrl} />
        ),
        color: "#FFBF69",
      },
      {
        key: "Manage Stocks",
        label: "Manage Stocks",
        icon: <InventoryIcon />,
        component: (
          <div className="mt-4">
            <ProjectProcurementParentComponnet
              orgId={orgId}
              showTab="Manage Commodity"
            />
          </div>
        ),
        color: "#FFBF69",
      },
      {
        key: "Create Trades",
        label: "Create Trades",
        icon: <StorefrontIcon />,
        component: (
          <div className="mt-4">
            <ProjectProcurementParentComponnet
              orgId={orgId}
              showTab="Seller Initiated Trade"
            />
          </div>
        ),
        color: "#FFBF69",
      },
      {
        key: "Ongoing Trades",
        label: "Ongoing Trades",
        icon: <ShoppingCartCheckoutIcon />,
        component: (
          <div className="mt-4">
            <ProjectProcurementParentComponnet
              orgId={orgId}
              showTab="Seller Ongoing Trade"
            />
          </div>
        ),
        color: "#FFBF69",
      },
    ];
   
    if (
      (projectName &&
        projectName.toLowerCase() ===
          "project maati - baseline assessment of value chain" &&
        id) ||
      (projectName &&
        projectName.toLowerCase() !==
          "project maati - baseline assessment of value chain")
    ) {
      items.push({
        key: "Field Activities",
        label: "Field Activities",
        icon: <Agriculture />,
        component: (
          <FieldActivities
            subProjectData={
              apiData?.organization_details?.project?.uploadedFiles
            }
          />
        ),
        color: "#FF8E53",
      });
    }

    if (
      projectName &&
      projectName.toLowerCase() ===
        "project maati - baseline assessment of value chain"
    ) {
      items.push({
        key: "Baseline Assessment",
        label: "Baseline Assessment",
        icon: <AssignmentTurnedIn />,
        component: (
          <FieldActivitiesNewUi
            subProjectData={project?.uploadedFiles || []}
            firstState={firstState}
            firstDistrict={firstDistrict}
            firstStateCode={firstStateCode}
            firstDistrictCode={firstDistrictCode}
          />
        ),
        color: "#FFBF69",
      });
    }
    if (
      projectName &&
      projectName.toLowerCase() ===
        "pilot study on 360 degree analytics of olive groves value chain using strong ai frameworks, portugal"
    ) {
      items.push({
        key: "Baseline Assessment",
        label: "Baseline Assessment",
        icon: <AssignmentTurnedIn />,
        component: (
          <OliveBaselineAssessment
            firstState={firstState}
            firstDistrict={firstDistrict}
            firstStateCode={firstStateCode}
            firstDistrictCode={firstDistrictCode}
          />
        ),
        color: "#FFBF69",
      });
       items.push({
        key: "Indian Usecases",
        label: "Indian Usecases",
        icon: <DashboardCustomizeIcon />,
        component: (
          <OliveProjectComp/>
        ),
        color: "#FFBF69",
      });
      
    }
   
    if (SaptashatiUrl) {
      items.push({
        key: "Saptashati",
        label: "Saptashati",
        icon: <Grain />,
        component: "",
        color: "#FFBF69",
      });
    }

    return items;
  }, [project, isCBBO, apiData, AdvisoryUrl, selectedCommodities,projectName]);
 

  useEffect(() => {
    let tabs = [];

    if (project && Object.keys(modules).length > 0) {
      tabs = menuItems
        .filter(
          (item) =>
            Object.keys(modules).includes(item.key) ||
            // item.key === "Live Mandi Prices" ||
            item.key === "Saptashati" ||
            item.key === "Baseline Assessment" || item.key==="Indian Usecases"
        )
        .map((item) => ({
          ...item,
          label: modules[item.key] || item.label,
        }));
    } else if (isCBBO) {
      tabs = menuItems.filter((item) =>
        ["FPO", "Farmers", "E-Mandi", "Live Mandi Prices"].includes(item.key)
      );
    } else {
      tabs = menuItems.filter((item) =>
        [
          "Farmers",
          "E-Mandi",
          "Live Mandi Prices",
          "Employees",
          "Aggregation",
        ].includes(item.key)
      );
    }

    setFilteredTabs(tabs);
  }, [menuItems, project, modules, isCBBO]);

  useEffect(() => {
    if (filteredTabs.length > 0 && !activeMenu) {
      setActiveMenu(filteredTabs[0]);
    }
  }, [filteredTabs, activeMenu]);

  const fetchMandiData = async () => {
    try {
      const state = store.getState();
      const response = await fetch(
        `${API_URL}/api/v1/onboarding/farmer-aggrigation?organization_id=${orgId}`,
        {
          headers: { authorization: `Bearer ${state.auth.accessToken}` },
        }
      );
      if (!response.ok) throw new Error("Network response was not ok");
      const data = await response.json();
      const filteredData = data?.data?.filter(
        (item) => item.current_status === "Procurement Done"
      );
      const totalQuantity = filteredData?.reduce((sum, item) => {
        let quantity = Number(item.quantity || 0);
        if (item.unit_of_quantity === "Quintals") quantity *= 100;
        return sum + quantity;
      }, 0);
      setMandiCard({ total: data?.data || [], totalQuantity });
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    fetchMandiData();
  }, []);
  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  const chartConfigMap = {
    Farmers: {
      color: "#FF8E53",
      // color:"#00BFA6",
      type: "area",
      icon: <People fontSize="small" />,
      chartData: [10, 15, 12, 18, 22, 25, 28],
    },
    "Land Holding": {
      color: "#6C63FF",
      type: "bar",
      icon: <Agriculture fontSize="small" />,
      chartData: [9, 10, 10, 10, 10, 10, 12],
    },
    Clusters: {
      color: "#2EC4B6",
      type: "area",
      icon: <Map fontSize="small" />,
      chartData: [8, 12, 15, 20, 18, 22, 25],
    },
    Crops: {
      color: "#2EC4B6",
      type: "area",
      icon: <Storefront fontSize="small" />,
      chartData: [8, 12, 15, 20, 18, 22, 25],
    },
    Commodities: {
      color: "#FFBF69",
      type: "area",
      icon: <Grain fontSize="small" />,
      chartData: [8, 12, 15, 20, 18, 22, 25],
    },
    Employees: {
      color: "#FFBF69",
      type: "line",
      icon: <MonetizationOn fontSize="small" />,
      chartData: [1, 3, 5, 7, 8, 10],
    },
    "E-Mandi": {
      color: "#FF6F61",
      type: "area",
      icon: <Storefront fontSize="small" />,
      chartData: [2, 4, 6, 8, 10, 12],
    },
    FPO: {
      color: "#00BFA6",
      type: "area",
      icon: <People fontSize="small" />,
      chartData: [1, 2, 3, 4, 5, 6],
    },
  };

  const stats = cards.map((card) => {
    const config = chartConfigMap[card.title] || chartConfigMap["Farmers"];
    return {
      title: card.title,
      value: card.total,
      color: config.color,
      icon: config.icon,
      type: config.type,
      chartData: config.chartData,
    };
  });

  const getChartOptions = (color) => ({
    chart: { sparkline: { enabled: true } },
    stroke: { curve: "smooth", width: 2 },
    fill: { opacity: 0.5 },
    colors: [color],
    tooltip: { enabled: false },
  });

  if (isLoading || !userProfile?.data) {
    return <ProjectSkeleton />;
  }

  if (!project && !isCBBO) {
    return (
      <Typography sx={{ p: 3 }}>
        <Spinner size="sm" />
      </Typography>
    );
  }
 

  return (
      <div className="">
        {console.log("poet",orgId)}
          <ProjectNavbar id={orgId} />
          <div className="p-lg-0 p-1 main-content">
    <Box sx={{ minHeight: "100vh", p: { xs: 0, sm: 3 } }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: 3,
          mb: 4,
        }}
      >
        {stats.map((stat, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: i * 0.2 }}
          >
            <Box
              sx={{
                background: `linear-gradient(145deg, #fff, ${stat.color}15)`,
                borderRadius: 4,
                p: 3,
                height: 140,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                boxShadow: `0 2px 2px ${stat.color}25`,
                overflow: "hidden",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-6px) scale(1.03)",
                  boxShadow: `0 1px 2px ${stat.color}40`,
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box
                    sx={{
                      bgcolor: stat.color,
                      color: "#fff",
                      p: 1.2,
                      borderRadius: "12px",
                      boxShadow: `0 4px 12px ${stat.color}60`,
                    }}
                  >
                    {stat.icon}
                  </Box>
                  <Typography fontWeight={600}>{t(stat.title)}</Typography>
                </Box>
                <Typography
                  variant="h6"
                  fontWeight={700}
                  sx={{
                    background: `linear-gradient(90deg, ${stat.color}, #333)`,
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  {stat.value}
                </Typography>
              </Box>
              <Chart
                options={getChartOptions(stat.color)}
                series={[{ data: stat.chartData }]}
                type={stat.type}
                height={50}
              />
            </Box>
          </motion.div>
        ))}
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 3,
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: 280 },
            backdropFilter: "blur(16px)",
            background: "rgba(255, 255, 255, 0.75)",
            borderRadius: 3,
            p: 3,
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            position: { md: "sticky" },
            top: 20,
            border: "1px solid rgba(255,255,255,0.4)",
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 700,
              mb: 1,
              color: "#333",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
            }}
          >
            {t("Quick Access")}
          </Typography>

          {filteredTabs.map((item, i) => {
            const isActive = activeMenu?.label === item.label;
            return (
              <motion.div
                key={i}
                whileHover={{ scale: 1.04 }}
                whileTap={{ scale: 0.98 }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: i * 0.05 }}
                onClick={() => {
                  if (item.key === "Saptashati" && SaptashatiUrl) {
                    window.open(SaptashatiUrl, "_blank");
                  } else {
                    if (activeMenu?.key === item.key) {
                      setActiveMenu(null);
                      setTimeout(() => setActiveMenu(item), 0);
                    } else {
                      setActiveMenu(item);
                    }
                  }
                }}
                style={{
                  padding: "14px 16px",
                  borderRadius: "14px",
                  background: isActive
                    ? `linear-gradient(135deg, ${item.color} 0%, ${item.color}99 100%)`
                    : "#ffffff",
                  color: isActive ? "#fff" : "#333",
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  fontWeight: 600,
                  fontSize: "15px",
                  boxShadow: isActive
                    ? `0 6px 18px ${item.color}50`
                    : "0 2px 8px rgba(0,0,0,0.05)",
                  cursor: "pointer",
                  transition: "all 0.25s ease",
                  border: isActive ? "none" : "1px solid rgba(0,0,0,0.05)",
                }}
              >
                <Box sx={{ fontSize: "18px" }}>{item.icon}</Box>
                <span className="mt-1">
               
                  {t(item.label)}
                </span>
              </motion.div>
            );
          })}
        </Box>

        <Box
          sx={{
            flex: 1,
            background: "rgba(255,255,255,0.9)",
            borderRadius: 3,
            p: 3,
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
            animation: "fadeIn 0.4s ease",
            overflow: "hidden",
            width: "100%",
          }}
        >
          {activeMenu?.component || (
            <Typography>Select a section from the sidebar.</Typography>
          )}
        </Box>
      </Box>
    </Box>
    </div>
    </div>
  );
};

export default OliveProjectDashboard;
